export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-v1-960-90c6db8f97b2735a010284a0989dc8d1.png";